import { render, staticRenderFns } from "./form.vue?vue&type=template&id=3582db0d&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3582db0d')) {
      api.createRecord('3582db0d', component.options)
    } else {
      api.reload('3582db0d', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=3582db0d&", function () {
      api.rerender('3582db0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/ip-filter/form.vue"
export default component.exports